// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"ceca292b","361":"fbad9352","718":"4dc3ab97","787":"132a59a5"}[chunkId] + ".chunk.js";
};